export default __webpack_public_path__ + "static/media/wayfarer.0cf85e4b.png";